class MsCryptoWrapper {
	static getMsCrypto() {
		let msCrypto;

		try {
			msCrypto = msCrypto || self.msCrypto;
		}
		catch(e) {
		}

		return msCrypto;
	}

	static isSupported() {
		return !!MsCryptoWrapper.getMsCrypto();
	}

	constructor() {
		let crypto = MsCryptoWrapper.getMsCrypto();
		if( !crypto ) {
			throw new Error('MsCryptoWrapper: msCrypto not supported');
		}

		this.crypto = crypto;
	}

	importKey( format, keyData, algo, extractable, usages ) {
		return new Promise((resolve, reject) => {
			try {
				let keyOp = this.crypto.subtle.importKey(format, keyData, algo, extractable, usages );
				keyOp.onerror = function (e) {	// eslint-disable-line no-unused-vars
					reject(new Error('MsCryptoWrapper.importKey failed'));
				};
				keyOp.oncomplete = function (e) {
					resolve(e.target.result);
				};
			}
			catch(err) {
				reject(err);
			}
		});
	}

	decrypt( algorithm, key, data ) {
		return new Promise((resolve, reject) => {
			try {
				let decryptOp = this.crypto.subtle.decrypt( algorithm, key, data );
				decryptOp.onerror = function (e) {	// eslint-disable-line no-unused-vars
					reject(new Error('MsCryptoWrapper.decrypt failed'));
				};
				decryptOp.oncomplete = function (e) {
					resolve(e.target.result);
				};
			}
			catch(err) {
				reject(err);
			}
		});
	}

	encrypt( algorithm, key, data ) {
		return new Promise((resolve, reject) => {
			try {
				let encryptOp = this.crypto.subtle.encrypt( algorithm, key, data );
				encryptOp.onerror = function (e) {	// eslint-disable-line no-unused-vars
					reject(new Error('MsCryptoWrapper.encrypt failed'));
				};
				encryptOp.oncomplete = function (e) {
					resolve(e.target.result);
				};
			}
			catch(err) {
				reject(err);
			}
		});
	}
}

export default MsCryptoWrapper;



// WEBPACK FOOTER //
// ./src/aes/MsCryptoWrapper.js